import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Divider, Space} from "antd";
import Search from "antd/es/input/Search";
import {arrRemove, globalData, setKey} from "../../util/util";
import List from "antd/es/list";
import Icon from "../Icon";
import {Link} from "react-router-dom";
import Tag from "antd/es/tag";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";

export default () => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [value, setValue] = useState("")
    const [data, setData] = useState([])
    const [tags, setTags] = useState([])

    useEffect(() => {
        let tags0 = localStorage.getItem("playerSearchTags")
        if (tags0) {
            setTags(JSON.parse(tags0))
        }
        axios.get(`player/online`).then(res => {
            if (!loading) {
                setKey(res, "handle")
                setData(res)
            }
        })
    }, [])
    const search = (value) => {
        setLoading(true)
        axios.get(`player/search/${value}`).then(res => {
            setKey(res, "handle")
            setData(res)
            setLoading(false)
        })
    }

    return <Space direction={'vertical'}>
        <Search value={value} onSearch={() => {
            if (!value) {
                return
            }
            tags.push(value)
            let tags0 = [...new Set(tags)]
            if (tags0.length > 10) {
                tags0.splice(0, 1)
            }
            setTags(tags0)
            localStorage.setItem("playerSearchTags", JSON.stringify(tags0))
            search(value)
        }
        } onChange={(e) => setValue(e.target.value) } size={'large'} style={{ width: "380px" }} placeholder={t('searchPlayerTip')} loading={loading} enterButton />
        <div style={{ height: "20px" }}>
            {
                tags.map((v) => <Tag size={'large'} key={v} closable onClose={() => {
                    arrRemove(tags, (item) => item === v)
                    localStorage.setItem("playerSearchTags", JSON.stringify(tags))
                    setTags(tags)
                }}>
                    <a onClick={() => {
                        setValue(v)
                        search(v)
                    }}>{v}</a>
                </Tag>)
            }
        </div>
        <Divider />
        {
            data.length > 0 &&
            <Space>
                <List style={{ width: "600px",fontSize: "20px" }}
                      size="small"
                      bordered
                      dataSource={data}
                      renderItem={(p) => <List.Item>
                          <div style={{ position: "relative", width: "100%" }}>
                              <Link to={`/player/${p.handle}`} >
                                  <Space style={{background: p.hack > 10 ? 'red' : '#f5f5f5'}}>
                                      {
                                          p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={40} icon={<UserOutlined />} />
                                              : <Avatar shape="square" size={40} icon={<UserOutlined />} />
                                      }
                                      <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
                                      <span>{p.handle}</span>
                                  </Space>
                              </Link>
                              <div style={{ position: "absolute", right: 10, top: -2 }}>
                                  <Icon  name={p.region} type={'region'} size={30} />
                              </div>
                          </div>
                      </List.Item>}
                />
            </Space>|| null
        }

    </Space>
}
